// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import IView from 'iview'
import 'iview/dist/styles/iview.css'
import VueSocketio from 'vue-socket.io'

Vue.config.productionTip = false
Vue.use(IView)
Vue.use(VueSocketio, 'http://127.0.0.1:6540')

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js